import { render, staticRenderFns } from "./RegisterGroupDropdown.vue?vue&type=template&id=16477e88&scoped=true&"
import script from "./RegisterGroupDropdown.vue?vue&type=script&lang=js&"
export * from "./RegisterGroupDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RegisterGroupDropdown.vue?vue&type=style&index=0&id=16477e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16477e88",
  null
  
)

export default component.exports